import { HeroSection } from "../components/sections/HeroSection";
import { StepsSection } from "../components/sections/StepsSection";
import { FeaturesSection } from "../components/sections/FeaturesSection";
import { StickerSection } from "../components/sections/StickerSection";
import { PrivacySection } from "../components/sections/PrivacySection";
import { ScannerDemoSection } from "../components/sections/ScannerDemoSection";
import { CtaBand } from "../components/sections/CtaBand";
import { ImagineSection, MoreThanParkingSection, NetworkSection, NoAppSection, WhenNotThereSection, WhyCarlinkSection } from "../components/sections/ValueSections";
import { usePageTitle } from "../lib/usePageTitle";

export default function HomePage() {
  usePageTitle();
  return (
    <>
      <HeroSection />
      <WhyCarlinkSection />
      <StepsSection />
      <ImagineSection />
      <MoreThanParkingSection />
      <FeaturesSection />
      <NetworkSection />
      <WhenNotThereSection />
      <StickerSection />
      <NoAppSection />
      <PrivacySection />
      <ScannerDemoSection />
      <CtaBand />
    </>
  );
}
